export const SizeBreakpointMarksOrdered = Object.freeze(
  ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'] as const, // !
)

export type SizeBreakpointMark = typeof SizeBreakpointMarksOrdered[number]

export type SizeBreakpoints = Record<SizeBreakpointMark, number>
